/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SpeedometerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVR4nO1Vy0ocQRSdVUxW6ioi+Ihb/YJgcDvYfR8KNffOLDIL8fETxgj+ixsZHyvFtTuj4lp0QEEUgzHxmYVKzTRaw/R014jgxoKCma6651Sfe051JvOWwxjTiqxTyLKIJGUgvUbWq8pvlpJds3uaBh4qFj8iyw9kuUTWh6QJpP+AZNrWeIETSS+wbMeBEcnXkPODsUQs22FouhPBh0cLPch61Oi0IecHieRb47eRQyLpigXPZrMtwLJbPY1uAMsEsJx7SPQbSOeR5KbyjHTHGPOhjgBIZ53Cqcoz1vVEAtLTYCQ3ENXPO2szMW6RC0fPcyRdQ9Z7L3DQfiA5c97qT427qlZMlgKTwU/qDZGffJaHZfkl4MFIbiAOPFKh5BDoQWozWVaD0UKfMeZTGngk057b4Ls0n4eOx61L4mVx6klu3B5cpfoctfNpP2pnWk5swp8JSMoeEi0D6OdhYzqAZcWjX/sOgS415SL2mbLoSjT+2gRAMvZEEASFdmD96yz+B5atxKDV7i3VXityQVRsq0mzjbdjsbkoHyseUixUnSg/HdLpRpfdVhSmX4i570h67NF8e/IZ6/vo/6bFqiOoxt588XEUNpokZXvlZzw+OKvIetsE+K2tsbWJ4O8jEzMeAWZfqS9lwKctAAAAAElFTkSuQmCC)
 */
export const SpeedometerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M17.38 21c.61 0 1.23-.18 1.7-.58a11 11 0 1 0-14.16 0c.47.4 1.09.58 1.7.58h10.76Zm.83-13.8a1 1 0 0 0-1.42-1.4l-4.27 4.27A2 2 0 0 0 10 12a2 2 0 1 0 3.93-.52l4.28-4.27ZM4 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3.05 3.95a1 1 0 1 1-1.41 1.41 1 1 0 0 1 1.41-1.41Zm9.9 1.41a1 1 0 1 1 1.41-1.41 1 1 0 0 1-1.41 1.41ZM6.13 7.32a1 1 0 1 1 .42-1.96 1 1 0 0 1-.42 1.96ZM12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
